<template>

    <svg  :class="svgClass" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g id="_1.-Foundations_Icons_ATAS_Icon_Play" data-name="1.-Foundations/Icons/ATAS_Icon_Play"><path class="cls-1" d="M11,6.05A2,2,0,0,0,8,7.77v22.5H8v4a4,4,0,0,0,4-4v-19l22.12,13L8,39.57H8a2.7,2.7,0,0,0,1.35,2.29,2.67,2.67,0,0,0,2.65,0L39,26a2,2,0,0,0,0-3.44Z"/></g></svg>

</template>

<script>
    export default {
        name: 'play',
        props: {
            svgClass: {
                type: String,
                default: 'svg-24'
            },
    }
}</script>

